import { Schema } from 'mongoose';

export interface ILinks {
  website?: string;
  facebook?: string;
  twitter?: string;
}

const links = new Schema(
  {
    website: {
      type: String,
    },
    facebook: {
      type: String,
    },
    twitter: {
      type: String,
    },
  },
  { _id: false },
);

export default links;
